import React, {useState} from 'react';
import { useEffect } from 'react';
import PurifierIcon from '../../../assets/img/dashboard/iconPurifier'
import PowerIcon from '../../../assets/img/dashboard/powerLarge';

const PurifierType = ({selectedItem, handlePostData, action}) => {
	const [power, setPower] = useState(!selectedItem.deviceState.power || selectedItem.deviceState.power === "false" ? false : true);
	const [stat, ] = useState(selectedItem.deviceState.pm25);
	const [mode, setMode] = useState(selectedItem.deviceState.mode);
	const [quality, setQuality] = useState();
	useEffect(()=>{
		let getValue = getQuality(Number(selectedItem.deviceState.pm25));
		setQuality(getValue)
	},[mode, quality, selectedItem.deviceState.pm25])


	const handleMode = (mode) => {
		if(mode === "auto"){
			setMode('manual')
			handlePostData("mode",'manual')
		}else if(mode === "manual"){
			setMode('sleep')
			handlePostData("mode",'sleep')
		}else if(mode === "sleep"){
			setMode('auto')
			handlePostData("mode",'auto')
		}
		action();
	}

	const getQuality = (quality) => {
		if(quality > 0 && quality <= 15){
			return '좋음'
		}else if(quality >= 16 && quality <= 35){
			return '보통'
		}else if(quality >= 36 && quality <= 75){
			return '나쁨'
		}else if( quality > 75){
			return '매우나쁨'
		}
	}
	const handleModeString = (mode) => {
		if(mode === "auto"){
			return "자동"
		}else if(mode === "manual"){
			return "수동"
		}else if(mode === "sleep"){
			return "취침"
		}
	}

	const handlePower = () => {
		setPower(!power)
		handlePostData("power",!power)

		action();
	}
	return (
		<>
		<section className="device-setting-body">
			<div className="device-display purifier">
				<div className={power ? "display active" : "display"}>
					<h2>{power ?   stat: "-"}</h2>
					<p>PM 2.5</p>
				</div>
				<section className="device-display-section">
					<p>
						<strong>{power ?  handleModeString(mode) : "-"}</strong>
						<span>동작 모드</span>
					</p>
					<p>
						<strong>{power ?  quality : "-"}</strong>
						<span>실내 공기 질</span>
					</p>
				</section>
			</div>
		
			<div className="device-control-wrap">
				<div className="device-control device-control-flex">
				<p onClick={()=>handleMode(mode)} className="fan-button">
						<span><PurifierIcon/></span>
						<span>동작 모드</span>
					</p>	
				</div>
			</div>
		
		</section>
		<section className="device-setting-footer">
		<div className="device-button">
			<button onClick={handlePower}>
				<PowerIcon/> 전원
			</button>
		</div>
	</section>
	</>
	);
}

export default PurifierType;